import axios from 'axios'

export const createCancelSource = axios.CancelToken.source
